import { Column, Table } from '@datum-group/isogd-openapi/lib';
import { Services } from '@project/API';
import {
  action,
  makeObservable,
  observable,
  reaction,
  runInAction,
} from 'mobx';
import { Filter } from '../shared/LayersTree/Tree/Filter';

export class CartogramFiltersStore {
  private _services: Services;

  @observable cartograms: Table[] = [];
  @observable isCartogramsLoading: boolean = false;
  @observable cartogramsError?: string = undefined;

  @observable tableColumns: Column[] = [];
  @observable isTableColumnsLoading: boolean = false;
  @observable tableColumnsError?: string = undefined;

  @observable cartogram?: string = undefined;
  @observable cartogramTable?: Table = undefined;
  @observable tableColumn?: string = undefined;

  private subscribesToDispose: (() => void)[] = [];

  constructor(services: Services) {
    this._services = services;
    makeObservable(this);
  }

  bind = () => {
    this.loadCartograms();

    const disposeColumnsFetch = reaction(
      () => this.cartogramTable,
      () => {
        if (!this.cartogramTable) return null;

        return this.loadtableColumns(this.cartogramTable.table_name);
      },
    );

    const disposeClearColumn = reaction(
      () => this.cartogram,
      () => (this.tableColumn = undefined),
    );

    this.subscribesToDispose = [disposeColumnsFetch, disposeClearColumn];
  };

  unbind = () => {
    this.subscribesToDispose?.forEach((dispose) => dispose());
  };

  @action loadCartograms = async () => {
    runInAction(() => {
      this.isCartogramsLoading = true;
    });
    try {
      const response = await this._services.cartograms.list(
        new Filter({ _limit: 0 }),
      );
      runInAction(() => {
        this.cartograms = response.results;
      });
    } catch (e) {
      runInAction(() => {
        this.cartogramsError = 'Произошла ошибка загрузки';
      });
    } finally {
      runInAction(() => {
        this.isCartogramsLoading = false;
      });
    }
  };

  @action loadtableColumns = async (tableName: string) => {
    runInAction(() => {
      this.isTableColumnsLoading = true;
    });
    try {
      const response = await this._services.table.apiColumnsList(
        undefined,
        undefined,
        {
          params: { _limit: 0, _page: 1, _page_size: 0, table_name: tableName },
        },
      );
      runInAction(() => {
        this.tableColumns = response.data.results;
      });
    } catch (e) {
      runInAction(() => {
        this.tableColumnsError = 'Произошла ошибка загрузки';
      });
    } finally {
      runInAction(() => {
        this.isTableColumnsLoading = false;
      });
    }
  };

  @action setCartogram = (cartogram: string) => {
    this.cartogram = cartogram;
    this.cartogramTable = this.cartograms.find(
      ({ table_name }) => table_name === cartogram,
    );
  };

  @action setTableColumn = (tableColumn: string) => {
    this.tableColumn = tableColumn;
  };
}
